import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const Leader = ({ size, colorCustom }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.37484 12.0001H6.37484C5.49078 12.0001 4.64294 11.6489 4.01781 11.0238C3.39269 10.3986 3.0415 9.5508 3.0415 8.66675C3.0415 7.78269 3.39269 6.93485 4.01781 6.30973C4.64294 5.6846 5.49078 5.33341 6.37484 5.33341H8.37484M8.37484 12.0001V2.66675H24.3748V12.0001M8.37484 12.0001C8.37484 14.1218 9.21769 16.1566 10.718 17.6569C12.2183 19.1572 14.2531 20.0001 16.3748 20.0001C18.4966 20.0001 20.5314 19.1572 22.0317 17.6569C23.532 16.1566 24.3748 14.1218 24.3748 12.0001M24.3748 12.0001H26.3748C27.2589 12.0001 28.1067 11.6489 28.7319 11.0238C29.357 10.3986 29.7082 9.5508 29.7082 8.66675C29.7082 7.78269 29.357 6.93485 28.7319 6.30973C28.1067 5.6846 27.2589 5.33341 26.3748 5.33341H24.3748M5.70817 29.3334H27.0415M13.7082 19.5467V22.6667C13.7082 23.4001 13.0815 23.9734 12.4148 24.2801C10.8415 25.0001 9.70817 26.9867 9.70817 29.3334M19.0415 19.5467V22.6667C19.0415 23.4001 19.6682 23.9734 20.3348 24.2801C21.9082 25.0001 23.0415 26.9867 23.0415 29.3334"
          stroke={colorCustom ? colorCustom : theme.palette.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Leader;
